import { useTranslation } from 'react-i18next'
import { Link } from 'wouter'

interface Game {
  id: string
  title: string
  cover: string
  description: string
  htmlFile: string
}

const games: Game[] = [
  {
    id: 'snake',
    title: 'Snake Game',
    cover: '/game/snake.png',
    description: 'Classic Snake game where you control a snake to eat food and grow longer',
    htmlFile: '/game/snake.html'
  },
  {
    id: 'tetris',
    title: 'Tetris',
    cover: '/game/tetris.png',
    description: 'Classic Tetris game where you arrange falling blocks to create complete lines',
    htmlFile: '/game/tetris.html'
  }
]

export function GamePage() {
  const { t } = useTranslation()

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold mb-8">{t('games.title')}</h1>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {games.map((game) => (
          <Link key={game.id} href={`/game/${game.id}`}>
            <div className="cursor-pointer hover:shadow-lg transition-shadow duration-300 rounded-lg overflow-hidden">
              <img
                src={game.cover}
                alt={game.title}
                className="w-full h-48 object-cover"
              />
              <div className="p-4">
                <h2 className="text-xl font-semibold mb-2">{game.title}</h2>
                <p className="text-gray-600">{game.description}</p>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  )
} 